import {Grid} from 'platform/foundation';

import {ReactNode} from 'react';

import {VEHICLE_ALBUM_IMAGE_SIZE} from './utils';

interface VehicleAlbumImageGridProps {
  children: ReactNode;
}

export function VehicleAlbumImageGrid(props: VehicleAlbumImageGridProps) {
  return (
    <Grid
      fill
      minColumnWidth={VEHICLE_ALBUM_IMAGE_SIZE.width}
      minHeight={VEHICLE_ALBUM_IMAGE_SIZE.height}
      spacing={3}
    >
      {props.children}
    </Grid>
  );
}
